import React, {
  useEffect 
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from 'data/redux/actions'

import { useUser } from './use-user'

export const useEventData = (gameId, eventId, instanceId) => {

  const dispatch = useDispatch()
  const { userId } = useUser()

  const game = useSelector(state => ((state?.user?.gameData|| {})[gameId] || {}) )
  const event = (game?.events || {})[eventId]

  useEffect(() => {

    if (event) return
    // refresh()

  }, [gameId, eventId])


  const refresh = () => {

    if (!gameId || !eventId) return
    dispatch(actions.userEventDataLoad(userId, gameId, eventId, instanceId))
  }

  const saveEventData = (data, progress) => {

    return dispatch(actions.userEventDataSave(userId, gameId, eventId, instanceId, { data: data, progress: progress }))
  }

  const updateKpiData = (values) => {

    return dispatch(actions.updateKpis(userId, gameId, eventId, instanceId, values))
  }

  return {
    refresh,
    updateKpiData,
    saveEventData,

    instance: event?.instance,
    kpis: event?.kpis || {},
    rankings: event?.rankings || {}, 
    awards: event?.awards || []
  }
}
